import vuetify from "@/main";
import ConflictCheckRoute from './check/ConflictCheckRoute.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.when('/matters/create', '/matters/newMatter');
  $stateProvider.state('conflict', {
    // tab=previous opens the log; check=<id> opens one saved check.
    url: "/conflict?tab&check",
    // ConflictCheckRoute picks between the existing page and the conflictCheck2
    // one at render time — the flag is not readable this early.
    ...vuetify(ConflictCheckRoute)
  });
}]);